import $ from 'jquery'
import _ from 'underscore'
import TemplateView from '../../TemplateView'
import * as Selectors from './selectors'
import * as Actions from './actions'
import {connect} from '../../redux/utils'
import {bindActionCreators} from 'redux'
import messageResource from '../../messageResource'
import InputLabel from './components/InputLabel'
import InputField from '../../components/InputField'
import Button from '../../components/Button'
import PasswordPolicyManager from '../../util/passwords/PasswordPolicyManager'
import NoteWithIcon from './components/NoteWithIcon'
import DropdownDialogWithPointerWrapper from '../../components/DropdownDialogWithPointerWrapper'
import ResetPasswordsDialog from './components/ResetPasswordsDialog'
import {NotResetPasswordReason, ResetStatus, SaveStatus} from './common'
import RequirementCheckbox from './components/RequirementCheckbox'
import {Connected as PasswordStrongStatusChecker} from './components/PasswordStrongStatusChecker'
import InformationBlock from '../../components/informationBlock/InformationBlock'
import CustomCheckbox from '../../components/customCheckbox/CustomCheckbox'
import {areMailSettingsSpecified} from '../mailSettings/selectors'
import {PasswordValidatorId} from '../../util/passwords/PasswordSettings'
import {CharsValidator} from '../../util/passwords/PasswordValidators'
import SimpleTooltip from '../../SimpleTooltip'
import {Moire} from '../../components/Moire'
import {PasswordPolicyLengthRange} from 'constants'

export class PasswordSettingsSectionContainer extends TemplateView {
    constructor({
        configurableRuleIds,
        ruleIds,
        anyRuleIsOn,

        minimalPasswordLength,
        minimalPasswordLengthError,

        settingsGotStronger,
        mailSettingsSpecified,
        currentPasswordInvalid,
        passwordValidationResult,

        rawSettings,
        resetStatus,
        passwordNotResetFor,
        saveStatus,

        checkboxComponent = RequirementCheckbox,
        onModify = () => {},
        onSave = () => {},
        setPasswordMinimalLength = value => {},
        setPasswordRequirement = (id, value) => {},
        setAllPasswordRequirements = value => {},

        resetAndSave = () => {},
        setCurrentPassword = () => {},
        setNewPassword = () => {},
        clearPasswords = () => {},
        setCurrentPasswordInvalid = () => {},
        setNewPasswordInvalid = () => {},
    }) {
        super();
        this.state = {
            configurableRuleIds,
            ruleIds,
            anyRuleIsOn,
            minimalPasswordLength,
            minimalPasswordLengthError,
            resetStatus,
            saveStatus,
            settingsGotStronger,
            rawSettings: {},
            isUserPasswordMatchesPolicy: false,
            mailSettingsSpecified: false,
            passwordValidationResult: {},
            currentPasswordInvalid: false,
            newPasswordInvalid: false,
        }
        this.params = {
            setPasswordMinimalLength,
            setPasswordRequirement,
            setAllPasswordRequirements,
            resetAndSave,
            setCurrentPassword,
            setNewPassword,
            clearPasswords,
            setCurrentPasswordInvalid,
            setNewPasswordInvalid,
        };
        this.callbacks = {onModify, onSave}
        this.checkboxComponent = checkboxComponent;

        this.onStatePropertyChanged("anyRuleIsOn", (value, oldValue) => {
            this.complexityCheckbox.setState({value});
            this.divWithCheckboxes.toggleClass("visible", value);
        });
        this.onStatePropertyChanged("minimalPasswordLength", (value, oldValue) => {
            this.minLengthInput.setState({value});
        });
        this.onStatePropertyDeeplyChanged("ruleIds", ruleIds => {
            //update checkboxes
            for (let ruleId of this.state.configurableRuleIds) {
                this.checkboxes[ruleId].setState({checked: _.contains(ruleIds, ruleId)})
            }
        });

        this.onAnyStatePropertyChanged(["settingsGotStronger", "mailSettingsSpecified"], () => {
            this.hintAboutReset.toggle(this.state.mailSettingsSpecified && this.state.settingsGotStronger)
        })

        this.onAnyStatePropertyChanged(['isUserPasswordMatchesPolicy', 'settingsGotStronger'], () => {
            this.resetConfirmDialog.setState({
                needToSetNewPassword: !this.state.isUserPasswordMatchesPolicy || this.state.settingsGotStronger,
            })
        })

        this.onStatePropertyChanged('currentPasswordInvalid', currentPasswordInvalid => {
            this.resetConfirmDialog.setState({
                currentPasswordInvalid
            })
        })

        this.onStatePropertyChanged('newPasswordInvalid', newPasswordInvalid => {
            this.resetConfirmDialog.setState({
                newPasswordInvalid
            })
        })

        this.onStatePropertyChanged('passwordValidationResult', passwordValidationResult => {
            this.resetPasswordsDialog.updatePolicyViolatedError(passwordValidationResult)
        })

        this.onStatePropertyChanged('rawSettings', newPasswordPolicy => {
            this.resetConfirmDialog.setState({
                newPasswordPolicy
            })
        })

        this.onStateDeeplyChanged((state, prevState) => {
            $("input[name=passwordSettings]", this.$el.parent()).val(JSON.stringify(state.rawSettings));
            if (this.state.saveStatus === SaveStatus.Modified) {
                this.callbacks.onModify(this.isValid());
            }
        });
        this.onStatePropertyChanged("minimalPasswordLengthError", errorMessage => {
            this.minLengthLabel.setState({errorMessage});
            this.minLengthInput.setState({errorMessage});
        });

        this.onAnyStatePropertyChanged(["saveStatus", "mailSettingsSpecified"], () => {
            if (this.state.mailSettingsSpecified)
                switch (this.state.saveStatus) {
                    case SaveStatus.Modified:
                        this.resetButton.setState({label: messageResource.getMessage("password_settings.reset_and_save")})
                        this.callbacks.onModify(this.isValid())
                        break
                    case SaveStatus.Saved:
                        this.resetButton.setState({label: messageResource.getMessage("password_settings.reset")})
                        this.callbacks.onSave()
                        break
                }
        })

        this.onStatePropertyChanged("passwordNotResetFor", () => this._updateNote());
        this.onStatePropertyChanged("resetStatus", status => {
            this._updateNote();
            let disabled = ResetStatus.isInProgress(status)
            this.complexityCheckbox.setState({disabled});
            this.minLengthInput.setState({disabled});
            for (let c of _.values(this.checkboxes)) {
                c.setState({disabled});
            }
            if (status === ResetStatus.ResetDone || status === ResetStatus.ResetAndSaveDone) {
                this.resetConfirmDialog.hide()
            }
        })

        this.onAnyStatePropertyChanged(['mailSettingsSpecified', 'resetStatus', 'minimalPasswordLengthError'], () => {
            let tooltipText = ''
            if (!!this.state.minimalPasswordLengthError)
                tooltipText = messageResource.getMessage('password_settings.minimum_password_length.short',
                    [PasswordPolicyLengthRange.MIN_PASSWORD_LENGTH, PasswordPolicyLengthRange.MAX_PASSWORD_LENGTH])
            else if (!this.state.mailSettingsSpecified)
                tooltipText = messageResource.getMessage('password_settings.reset.cant_reset_tooltip')

            this.resetButton.setState({
                disabled: !this.state.mailSettingsSpecified || ResetStatus.isInProgress(this.state.status) || !!this.state.minimalPasswordLengthError,
                disableTooltipText: tooltipText,
            })
        })
    }

    isValid() {
        return !this.state.minimalPasswordLengthError;
    }

    useUnderscoreTemplate() {
        return false;
    }

    templateHtml() {
        return '<div class="passwordSettings_container collapsibleBlockContent">' +
               '    <div class="passwordSettings_controls"></div>' +
               '    <hr/>' +
               '    <div class="passwordSettings_reset"></div>' +
               '</div>'
    }

    _updateNote() {
        switch (this.state.resetStatus) {
            case ResetStatus.Initial:
                this.note.note(messageResource.getMessage("password_settings.reset.hint_before_reset"))
                break;
            case ResetStatus.Resetting:
            case ResetStatus.ResettingAndSaving:
                this.note.progress(messageResource.getMessage("password_settings.reset.hint_during_reset"))
                break;
            case ResetStatus.ResetDone:
            case ResetStatus.ResetAndSaveDone:
                let notes = [];
                if (this.state.resetStatus === ResetStatus.ResetAndSaveDone) {
                    notes.push(messageResource.getMessage("password_settings.reset.hint_after_save"))
                }
                if (this.state.passwordNotResetFor.length) {

                    let key = {
                        [NotResetPasswordReason.LAST_ADMIN_IN_ACTITIME]: "password_settings.reset.hint_after_reset_except_last_at_admin",
                        [NotResetPasswordReason.LAST_ADMIN_IN_ACTIPLANS]: "password_settings.reset.hint_after_reset_except_last_ap_admin"
                    }[this.state.passwordNotResetFor[0].reason]
                    notes.push(messageResource.getMessage(key, [this.state.passwordNotResetFor[0].fullName]))
                } else {
                    notes.push(messageResource.getMessage("password_settings.reset.hint_after_reset"));
                }

                this.note.success(notes);
                break;
        }
    }

    afterRender() {
        let $controls = this.$el.find(".passwordSettings_controls");
        let $reset = this.$el.find(".passwordSettings_reset");

        let $controlRow1 = $("<div/>").addClass("control_row").appendTo($controls);
        let $controlRow2 = $("<div/>").addClass("control_row").appendTo($controls);
        this.minLengthLabel = new InputLabel({
            text: messageResource.getMessage("password_settings.minimum_password_length"),
            additionalClass: "passwordSettings_label"
        }).init($controlRow1);
        this.minLengthInput = new InputField({
            type: "number",
            maxLength: 4,
            value: this.state.minLength,
            id: "passwordSettings_minlength",
            onChange: value => this.params.setPasswordMinimalLength(value)
        }).init($controlRow1);
        this.minLengthLabelSuffix = $(`<span class="passwordSettings_suffix">
            ${messageResource.getMessage("password_settings.minimum_password_length.suffix")}
            </span>`).appendTo($controlRow1);

        this.complexityCheckbox = new this.checkboxComponent({
            label: messageResource.getMessage('password_settings.check_complexity_label'),
            onValueChange: (checked) => this.params.setAllPasswordRequirements(checked)
        }).init($controlRow2);

        this.divWithCheckboxes = $("<div></div>").addClass("passwordSettings_checkboxList").appendTo($controls);

        this.checkboxes = {};
        for (let rule of this.state.configurableRuleIds) {
            this.checkboxes[rule] = new CustomCheckbox({
                label: PasswordPolicyManager.getSingleTipFor(rule),
                onChange: ({checked}) => this.params.setPasswordRequirement(rule, checked),
                containerAdditionalClass: 'checkboxContainer',
                checkboxAdditionalClass: 'checkboxInput',
                checkmarkAdditionalClass: 'hiddenCheckmark'
            }).init(this.divWithCheckboxes)
        }

        const specialValidator = CharsValidator.RuleToName[PasswordValidatorId.SPECIAL_VALIDATOR]
        if (this.state.configurableRuleIds.includes(specialValidator)) {
            this.checkboxes[specialValidator].find(".label").html(messageResource.getMessage('password_validation.characters.special.hint'))
            const $specialCharacter = this.checkboxes[specialValidator].find('.specialCharacter')
            const tooltip = new SimpleTooltip({
                text: messageResource.getMessage('password_validation.characters.special.hint.tooltip'),
                extraClass: 'specialCharacterTooltip',
            }).init($('body'))
            tooltip.subscribeToMouseEvents($specialCharacter)
        }

        this.resetPasswordsDialog = new ResetPasswordsDialog({
            okButtonClick: (e) => {
                this.params.resetAndSave()
            },
            cancelButtonClick: (e) => {
                e.preventDefault()
                this.resetConfirmDialog.hide()
            },
            updateCurrentPasswordCb: this.params.setCurrentPassword,
            updateNewPasswordCb: this.params.setNewPassword,
            updateNewPasswordInvalidCb: this.params.setNewPasswordInvalid,
        })

        this.resetConfirmDialog = new DropdownDialogWithPointerWrapper({
            additionalClass: "generalSettings_resetPasswordsDialog_wrapper",
            dialogOffsets: {left: 0, top: -15},
            dialog: this.resetPasswordsDialog,
            onHide: () => {
                Moire.getInstance().hide()
                this.resetPasswordsDialog.clearFields()
                this.params.setCurrentPasswordInvalid(false)
                this.params.setNewPasswordInvalid(false)
                this.params.clearPasswords()
            },
        }).init(this.getEl());


        this.hintAboutReset = new InformationBlock({
            additionalClass: "generalSettings_passwordSettings_resetHint with_pointer",
            title: messageResource.getMessage("password_settings.reset_invitation.title"),
            paragraphs: [messageResource.getMessage("password_settings.reset_invitation.text")]
        }).init($controls);
        this.hintAboutReset.hide();

        this.resetButton = new Button({
            label: messageResource.getMessage("password_settings.reset"),
            additionalClass: "greyButton",
            withDisableTooltip: true,
            tooltipAdditionalClass: 'passwordPolicyResetButtonTooltip',
            onClickCb: () => {
                this.resetConfirmDialog.showAt(this.resetButton.$el, {my: "left bottom", at: "left top"});
                Moire.getInstance().show()
            }
        }).init($reset);

        this.note = new NoteWithIcon().init($reset);

        this.strongChecker = new PasswordStrongStatusChecker()
    }
}


export const PasswordSettingsSectionContainerConnected = connect((state) => ({
    rawSettings: Selectors.getRawSettings(state),
    minimalPasswordLength: Selectors.getMinimalPasswordLength(state),
    minimalPasswordLengthError: Selectors.getMinPasswordLengthError(state),
    configurableRuleIds: Selectors.getConfigurablePasswordRules(state),
    ruleIds: Selectors.getTurnedOnConfigurablePasswordRules(state),
    anyRuleIsOn: Selectors.isAnyPasswordRequirementOn(state),

    settingsGotStronger: Selectors.isPasswordRulesGotStronger(state),
    mailSettingsSpecified: areMailSettingsSpecified(state),

    resetStatus: Selectors.getResetState(state),
    saveStatus: Selectors.getModificationState(state),
    passwordNotResetFor: Selectors.getPasswordNotResetFor(state),
    currentPasswordInvalid: Selectors.isCurrentPasswordInvalid(state),
    newPasswordInvalid: Selectors.isNewPasswordInvalid(state),
    isUserPasswordMatchesPolicy: Selectors.isUserPasswordMatchesPolicy(state),
    passwordValidationResult: Selectors.getPasswordValidationResult(state),
}), (dispatch) => ({
    setPasswordMinimalLength: bindActionCreators(Actions.setPasswordMinimalLength, dispatch),
    setPasswordRequirement: bindActionCreators(Actions.setPasswordRequirement, dispatch),
    setAllPasswordRequirements: bindActionCreators(Actions.setAllPasswordRequirements, dispatch),
    resetAndSave: bindActionCreators(Actions.startReset, dispatch),
    setCurrentPassword: bindActionCreators(Actions.setCurrentPassword, dispatch),
    setNewPassword: bindActionCreators(Actions.setNewPassword, dispatch),
    clearPasswords: bindActionCreators(Actions.clearPasswords, dispatch),
    setCurrentPasswordInvalid: bindActionCreators(Actions.setCurrentPasswordInvalid, dispatch),
    setNewPasswordInvalid: bindActionCreators(Actions.setNewPasswordInvalid, dispatch),
}))(PasswordSettingsSectionContainer);


// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/PasswordSettingsSectionContainer.js